import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter  } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
//Route Dictionary
import RouteManager from "./routes";
//Parent Styles
import "./index.css";
import constants from "./constants/constants";
const App = () => (
	<BrowserRouter basename={constants.BaseUrl}>
		<RouteManager/>
	</BrowserRouter>
);
ReactDOM.render(<App/>, document.getElementById("root"));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();